import styled from 'styled-components'

export const SubTitlePageWrapper = styled.h2`
color: var(--black-10, #3D3D3D);
font-size: 18px;
font-weight: 500;
`
